import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import RegistrationClosed from './RegistrationClosed';

interface RegistrationAvailabilityRouteProps {
  children: React.ReactNode;
}

const RegistrationAvailabilityRoute: React.FC<RegistrationAvailabilityRouteProps> = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth();
  const [isAcceptingRegistrations, setIsAcceptingRegistrations] = useState<boolean | null>(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkRegistrationStatus = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'camp');
        const settingsDoc = await getDoc(settingsRef);
        
        if (settingsDoc.exists()) {
          setIsAcceptingRegistrations(settingsDoc.data()?.acceptingRegistrations ?? false);
        } else {
          setIsAcceptingRegistrations(false);
        }
      } catch (error) {
        console.error('Error checking registration status:', error);
        setIsAcceptingRegistrations(false);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkRegistrationStatus();
  }, []);

  if (loading || checkingStatus) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Admin users can always proceed
  if (isAdmin) {
    return <>{children}</>;
  }

  // Non-admin users are blocked if registrations are not being accepted
  if (!isAcceptingRegistrations) {
    return <RegistrationClosed />;
  }

  return <>{children}</>;
};

export default RegistrationAvailabilityRoute; 